import { render, staticRenderFns } from "./associaStati.vue?vue&type=template&id=17f853fc&"
import script from "./associaStati.vue.ts?vue&type=script&lang=ts&"
export * from "./associaStati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports